import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Constants } from '../common';
import { map } from 'rxjs/operators';
import { PermissionService } from './permission.service';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import { CustomURLEncoder } from '../models';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<any>;
  public currentUser: Observable<any>;

  constructor(
    private http: HttpClient,
    private permissionService: PermissionService,
    private storageService: StorageService,
    private router: Router
    ) { 
    this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  public deleteCurrentUserValue(): any {
    this.currentUserSubject.next(null);
  }

  login(username: string, password: string) {

    const body = new HttpParams({ encoder: new CustomURLEncoder() })
      .set('grant_type', 'password')
      .set('username', username)
      .set('password', password);

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    });

    return this.http.post<any>(`${Constants.API_URL}token`, body.toString(), { headers })
      .pipe(map(user => {
        if (user && user.access_token) {
          this.storageService.SetCurrentSession(user);
          this.currentUserSubject.next(user);
          this.permissionService.GetPermissionsByUser(user.Id).subscribe(next => {
            if (next.Result) {
              this.storageService.SetPermissions(next.Data);
            }
            else {
            }
          }, error => {

          });
        }

        return user;
      }));
  }

  anyActiveSession() {
    let session: any = this.storageService.GetCurrentSession();

    if (!session) return false;
   
    const sessionExpireDate = new Date(session.ExpireTime);

    return sessionExpireDate > new Date();
  }

  loadSessionFromLocalStorage() {
    this.currentUserSubject.next(this.storageService.GetCurrentSession());
  }

  logout() {
    this.storageService.ClearCurrentSession();
    this.storageService.ClearPermissions();
    this.deleteCurrentUserValue();
    this.router.navigate(['login']);
  }
}
